module.exports = __webpack_public_path__ + "static/media/hero.cef7e2b1.jpg";